module.exports = __webpack_public_path__ + "f2b28483d9ff60cb52a641346f013a15.svg";